// src/redux/actions/purchaseLogsActions.js

import apiClient from '../../../apiClient/apiClient';
import {
    FETCH_PURCHASE_LOGS_REQUEST,
    FETCH_PURCHASE_LOGS_SUCCESS,
    FETCH_PURCHASE_LOGS_FAILURE,
} from '../constant/purchaseLogsConstants';

/**
 * Action to fetch purchase logs for a specific event.
 * @param {string} eventId - The ID of the event.
 * @param {number} page - The page number to fetch.
 * @param {number} pageSize - The number of logs per page.
 */
export const fetchPurchaseLogs = (eventId, page = 1, pageSize = 10) => async (dispatch) => {
    try {
        dispatch({ type: FETCH_PURCHASE_LOGS_REQUEST });

        // Add error handling for the API call
        let response;
        try {
            response = await apiClient.get(
                `api/check-in/logs/${eventId}/?page=${page}&page_size=${pageSize}`
            );
            console.log(`[API SUCCESS] Fetched logs for event ${eventId}, page ${page}`, response.data);
        } catch (apiError) {
            console.error(`[API ERROR] Failed to fetch logs for event ${eventId}, page ${page}:`, apiError);
            
            // If we get a 404 on a page > 1, try fetching page 1 instead
            if (apiError.response?.status === 404 && page > 1) {
                console.log(`[API RETRY] Fetching page 1 for event ${eventId}`);
                response = await apiClient.get(`api/check-in/logs/${eventId}/?page=1&page_size=${pageSize}`);
            } else {
                throw apiError; // Re-throw if not a pagination 404 issue
            }
        }

        dispatch({
            type: FETCH_PURCHASE_LOGS_SUCCESS,
            payload: { 
                eventId, 
                data: response.data,
                pagination: {
                    count: response.data.count || 0,
                    next: response.data.next,
                    previous: response.data.previous,
                    currentPage: page,
                    pageSize: pageSize
                }
            },
        });
    } catch (error) {
        dispatch({
            type: FETCH_PURCHASE_LOGS_FAILURE,
            payload: error.response?.data?.detail || error.message,
        });
    }
};
